import { render, staticRenderFns } from "./LicencaManage.vue?vue&type=template&id=368d3e3c&scoped=true"
import script from "./LicencaManage.vue?vue&type=script&lang=js"
export * from "./LicencaManage.vue?vue&type=script&lang=js"
import style0 from "./LicencaManage.vue?vue&type=style&index=0&id=368d3e3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368d3e3c",
  null
  
)

export default component.exports